import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CreateScreeningRoundPayload, FetchRoundsParams } from '../../models/ai-screening.model';

@Injectable({
  providedIn: 'root'
})
export class AiScreeningService {
  private apiUrl = environment.hrmsApiUrl;

  constructor(private http: HttpClient) { }

  // POST /rounds
  createScreeningRound(payload: CreateScreeningRoundPayload): Observable<any> {
    const url = `${this.apiUrl}/rounds`;
    return this.http.post<any>(url, payload);
  }

  // GET /rounds
  getRounds(paramsConfig: FetchRoundsParams = {}): Observable<any> {
    const url = `${this.apiUrl}/rounds`;

    let params = new HttpParams()
      .set('page', (paramsConfig.page || 1).toString())
      .set('limit', (paramsConfig.limit || 20).toString());

    if (paramsConfig.search) {
      params = params.set('search', paramsConfig.search);
    }
    if (paramsConfig.status) {
      params = params.set('status', paramsConfig.status);
    }
    if (paramsConfig.is_expired !== undefined && paramsConfig.is_expired !== null) {
      params = params.set('is_expired', paramsConfig.is_expired.toString());
    }
    if (paramsConfig.job_id) {
      params = params.set('job_id', paramsConfig.job_id.toString());
    }
    if (paramsConfig.company_id) {
      params = params.set('company_id', paramsConfig.company_id.toString());
    }

    return this.http.get<any>(url, { params });
  }

  // GET /designations
  getDesignations(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/designations`);
  }

  // GET /rounds/:id
  getRoundById(id: string | number): Observable<any> {
    const url = `${this.apiUrl}/rounds/${id}`;
    return this.http.get<any>(url);
  }
  // POST /rounds/:id/candidates/bulk
  inviteCandidatesToRound(roundId: string | number, payload: { emails: string[], phones: string[] }): Observable<any> {
    const url = `${this.apiUrl}/rounds/${roundId}/candidates/bulk`;
    return this.http.post<any>(url, payload);
  }

  // PATCH /rounds/:id
  updateScreeningRound(id: string | number, payload: { valid_until: string }): Observable<any> {
    const url = `${this.apiUrl}/rounds/${id}`;
    return this.http.patch<any>(url, payload);
  }

  // DELETE /rounds/:id
  deleteScreeningRound(id: string | number): Observable<any> {
    const url = `${this.apiUrl}/rounds/${id}`;
    return this.http.delete<any>(url);
  }

  // GET /rounds/:id/export
  exportRoundCandidates(id: string | number): Observable<Blob> {
    const url = `${this.apiUrl}/rounds/${id}/export`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
